import React, { FC } from 'react';
import {
  LogoAutodeskAccIcon,
  LogoAutodeskBim360Icon,
} from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import { CellProps, isAcsUnified } from '../../../utils';
import { Flex } from '../../Views/SharedStyleComponents';

const IconSize = 24;

export const TypeCell: FC<CellProps> = ({ row }) => (
  <Flex data-testid={`row type:${row.original.id}`}>
    {isAcsUnified(row.original) ? (
      <LogoAutodeskAccIcon
        size={IconSize}
        style={{ color: theme.colors.acsLogoBlue }}
      />
    ) : (
      <LogoAutodeskBim360Icon
        size={IconSize}
        style={{ color: theme.colors.adskBlue700 }}
      />
    )}
  </Flex>
);
